import React from 'react';

import { ART_MORPH } from '../../useIngredientsMorph';
import { Row, Title } from './IngredientsHeading.styles';

/**
 * A chemistry flask in the shared icon set's hand (24px grid, 1.6 round stroke, solid dots), tinted by `currentColor`.
 * Page-local until the shared Icon set gains one.
 */
const FlaskGlyph = ({ size = 20 }: { size?: number }): React.ReactElement => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth={1.6}
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    <path d="M9.5 3.5h5" />
    <path d="M10.5 3.5v5.2L5.6 17.4A1.8 1.8 0 0 0 7.2 20h9.6a1.8 1.8 0 0 0 1.6-2.6L13.5 8.7V3.5" />
    <path d="M7.8 14.2c1.4-.7 2.8-.7 4.2 0s2.8.7 4.2 0" />
    <circle cx="10.6" cy="17" r="0.9" fill="currentColor" stroke="none" />
    <circle cx="13.6" cy="16.4" r="0.7" fill="currentColor" stroke="none" />
  </svg>
);

/** The Ingredients heading (the rail's, and the sheet's header): the shared section title with a flask for what Lumio
 *  mixes the style from. Named for the sheet-to-rail morph, which glides it from one to the other. */
export const IngredientsHeading = ({ title, className }: { title: string; className?: string }): React.ReactElement => (
  <Row className={className} data-art-morph={ART_MORPH.head}>
    <FlaskGlyph />
    <Title title={title} />
  </Row>
);

export default IngredientsHeading;
